module.exports = __webpack_public_path__ + "svg/illustration-shipping.00a0cd1.svg";